// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionID = function (x) {
    return x;
};
var tsBridgeSectionID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SectionID")("__brandSectionID"));
    }
};
var writeSectionID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSectionID = Data_Show.showString;
var readSectionID = Simple_JSON.readString;
var ordSectionID = Data_Ord.ordString;
var newtypeSectionID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionID = SectionID;
var eqSectionID = Data_Eq.eqString;
export {
    SectionID,
    makeSectionID,
    unwrap,
    newtypeSectionID,
    eqSectionID,
    ordSectionID,
    showSectionID,
    readSectionID,
    writeSectionID,
    tsBridgeSectionID
};
//# sourceMappingURL=index.js.map
